import axios from 'axios'
import qs from 'qs'
import { Message, Loading } from 'element-ui'
import storageHelper from './storageHelper'

let loading //定义loading变量
let needLoadingRequestCount = 0

function startLoading() {
	if (needLoadingRequestCount === 0) {
		loading = Loading.service({
			lock: true,
			background: 'hsla(0,0%,100%,.9)',
		})
	}
	needLoadingRequestCount++
}

function endLoading() {
	if (needLoadingRequestCount > 0) {
		needLoadingRequestCount--
	}
	if (needLoadingRequestCount === 0) {
		loading.close()
	}
}

//默认值
if (process.env.NODE_ENV === 'development') {
	// axios.defaults.baseURL = '';
	axios.defaults.baseURL = 'https://api.mabangerp.com'
} else {
	axios.defaults.baseURL = 'https://api.mabangerp.com'
	// axios.defaults.baseURL = '/api';
}
axios.defaults.headers.post['Content-Type'] = 'application/json' //application/x-www-form-urlencoded
axios.defaults.timeout = 60000
//请求拦截器
axios.interceptors.request.use(
	(config) => {
		if (config.data instanceof FormData) {
			config.headers = {
				'Content-Type': 'multipart/form-data',
			}
		} else {
			config.data = JSON.stringify(config.data)
			config.headers = {
				'Content-Type': 'application/json',
			}
		}
		config.headers.Authorization = 'Bearer ' + storageHelper.get('mabangerp_token')
		config.headers.Accept = 'application/json'

		return config
	},
	(error) => {
		Message.error({ message: '请求超时!' })
		return Promise.reject(error)
	}
)
//响应拦截器
axios.interceptors.response.use(
	(res) => {
		// endLoading()
		let resData = res.data
		if (resData.code === 200) {
			return resData.data
		} else {
			if (resData.msg == '余额不足') {
				Message.error({ message: resData.msg })
				return 1
			} else if (resData.msg == '用户已领取') {
				return
			} else if (resData.code == 204) {
				Message.warning({ message: '数据为空' })
			} else {
				Message.error({ message: resData.msg })
			}
			return Promise.reject(resData)
		}
	},
	(error) => {
		// if (!error.response) {
		// 	Message.error({ message: '您的网络断掉了!' })
		// }
		if (error.response.status == 504 || error.response.status == 404) {
			Message.error({ message: '安全验证过期，请重新登陆!' })
		} else if (error.response.status == 403) {
			Message.error({ message: '安全验证过期，请重新登陆!' })
		} else {
			Message.error({ message: '发生错误!!' })
		}
		// endLoading()
		return Promise.reject(error)
	}
)

export function get(url, params = {}, isNeedLoading = true) {
	if (isNeedLoading) {
		startLoading()
	}
	return new Promise((resolve, reject) => {
		axios
			.get(url, {
				params: params,
				paramsSerializer: (params) => {
					return qs.stringify(params, { indices: false, skipNulls: true })
				},
			})
			.then((response) => {
				if (isNeedLoading) {
					endLoading()
				}
				resolve(response)
			})
			.catch((err) => {
				if (isNeedLoading) {
					endLoading()
				}
				reject(err)
			})
	})
}

export function post(url, params = {}, isNeedLoading = true) {
	if (isNeedLoading) {
		startLoading()
	}
	return new Promise((resolve, reject) => {
		axios.post(url, params).then(
			(response) => {
				if (isNeedLoading) {
					endLoading()
				}
				resolve(response)
			},
			(err) => {
				if (isNeedLoading) {
					endLoading()
				}
				reject(err)
			}
		)
	})
}

export function dele(url, params = {}) {
	return new Promise((resolve, reject) => {
		axios
			.delete(url, {
				params: params,
				paramsSerializer: (params) => {
					return qs.stringify(params, { indices: false, skipNulls: true })
				},
			})
			.then((response) => {
				resolve(response)
			})
			.catch((err) => {
				reject(err)
			})
	})
}

export function put(url, params = {}) {
	return new Promise((resolve, reject) => {
		axios.put(url, params).then(
			(response) => {
				resolve(response)
			},
			(err) => {
				reject(err)
			}
		)
	})
}
